import { makeStyles } from '@material-ui/core/styles';

const usePlainSecondaryCtaStyles = makeStyles(theme => ({
  root: {
    padding: 0,
    letterSpacing: 'normal',
    textTransform: 'none',
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
    lineHeight: 1.2,
    '&:hover': {
      backgroundColor: 'transparent',
      opacity: '0.7'
    }
  }
}));

export default usePlainSecondaryCtaStyles;
